import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取空运进口
export function getAiJobDetail(uuid) {
  return request({
    url: URL.booking.airImport.aiDetail,
    method: 'get',
    params: { uuid }
  })
}

// 获取空运进口-关联其他子表取出
export function loadAirImportJobRelated(data) {
  return request({
    url: URL.booking.airImport.aiDetail,
    method: 'post',
    data: data
  })
}

// 仓库操作-列表查询
export function queryAiWareHouse(data) {
  return request({
    url: URL.booking.airImport.queryWareHouse,
    method: 'post',
    data
  })
}

export function isContractExpiredForbidCreateJob(cmpIdx) {
  return request({
    url: URL.booking.isContractExpiredForbidCreateJob,
    method: 'get',
    params: { cmpIdx }
  })
}

// 高级查询
export function advancedQuery(data) {
  return request({
    url: URL.booking.airImport.advancedQuery,
    method: 'post',
    data
  })
}

// 保存空运进口信息
export function saveAirImport(data, fullError, forbidAlert) {
  return request({
    url: URL.booking.airImport.saveAirImport,
    method: 'post',
    fullError,
    forbidAlert,
    data
  })
}

export function queryJobNoRule(type) {
  return request({
    url: URL.booking.queryJobNoRule,
    method: 'get',
    params: { type }
  })
}

export function doCopyJob(data) {
  return request({
    url: URL.booking.airImport.doCopyJob,
    method: 'post',
    data
  })
}

// 批量复制小票，组装数据返回给前台
export function batchCloneLcLJob(params) {
  return request({
    url: URL.booking.airImport.batchCloneLcLJob,
    method: 'get',
    params
  })
}

// 根据job拼箱主票和查询条件查询，隐含条件：未拼票的job.....
export function getAirImportJobsByLclMasterJob(params) {
  return request({
    url: URL.booking.airImport.getAirImportJobsByLclMasterJob,
    method: 'get',
    params
  })
}

// 保存复制的业务（批量）
export function saveCopyJob(data) {
  return request({
    url: URL.booking.airImport.saveCopyJob,
    method: 'post',
    data
  })
}

// 最近修改的单子
export function queryLastModifyBookingByDay(data) {
  return request({
    url: URL.booking.airImport.queryLastModifyBookingByDay,
    method: 'post',
    data
  })
}

// 投保
export function toInsure(data) {
  return request({
    url: URL.booking.airImport.toInsure,
    method: 'post',
    data
  })
}

// 校验主单号是否重复
export function checkMblRepeatOrNot(data) {
  return request({
    url: URL.booking.airImport.checkMblRepeatOrNot,
    method: 'post',
    data
  })
}
